import { useInfiniteQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'

interface IUseFetchInfinite {
	name: string | readonly (string | { readonly query: string | undefined })[]
	endpoint: string
	enabled?: boolean
	options?: any
	query?: string
}

export interface InfiniteResult<T = any> {
	next: string
	previous: string
	results: T[]
}

export const useFetchInfinite = <T>({
	name,
	endpoint,
	query,
	enabled = true,
	options
}: IUseFetchInfinite) => {
	const axiosPrivate = useAxiosPrivate()

	const fetchData = async ({ pageParam }: { pageParam: string }) => {
		const res = await axiosPrivate.get(
			`${endpoint}${pageParam ? `?cursor=${pageParam}` : ''}${query ? `?${query}` : ''}`
		)

		return res.data
	}

	const {
		data,
		isPending: isLoading,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage
	} = useInfiniteQuery<InfiniteResult<T>>({
		queryKey: [name],
		queryFn: async ({ pageParam }: { pageParam: any }) => fetchData({ pageParam }),
		initialPageParam: undefined,
		getNextPageParam: (lastPage) => {
			let page: string | undefined

			if (lastPage.next) {
				const url = new URL(lastPage.next)
				page = url.searchParams.get('cursor')!
			}

			return page
		},
		enabled,
		refetchOnWindowFocus: false,
		...options
	})

	return {
		data,
		isLoading,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage
	}
}
